// Mutations enums
export enum MutationTypes {
  SET_DARK_MODE = "SET_DARK_MODE",
  SET_COUNTRY_ADDRESS = "SET_COUNTRY_ADDRESS",
  SET_ORDER_LIBRARY = "SET_ORDER_LIBRARY",
  SET_ADDRESS_MODE = "SET_ADDRESS_MODE",
}
